export const ORG_CHANGE_SHOW_DIALOGS = "ORG_CHANGE_SHOW_DIALOGS";

export const ORG_CLEAR_STATE = "ORG_CLEAR_STATE";

export const ORG_GET_ALL_TENANTS = "ORG_GET_ALL_TENANTS";
export const ORG_GET_ALL_TENANTS_SUCCESS = "ORG_GET_ALL_TENANTS_SUCCESS";
export const ORG_GET_ALL_TENANTS_FAIL = "ORG_GET_ALL_TENANTS_FAIL";

export const ORG_ADD_TENANT = "ORG_ADD_TENANT";
export const ORG_ADD_TENANT_SUCCESS = "ORG_ADD_TENANT_SUCCESS";
export const ORG_ADD_TENANT_FAIL = "ORG_ADD_TENANT_FAIL";

export const ORG_EDIT_TENANT = "ORG_EDIT_TENANT";
export const ORG_EDIT_TENANT_SUCCESS = "ORG_EDIT_TENANT_SUCCESS";
export const ORG_EDIT_TENANT_FAIL = "ORG_EDIT_TENANT_FAIL";

export const COMPARE_POLYGONS_CHART = "COMPARE_POLYGONS_CHART";
export const COMPARE_POLYGONS_CHART_SUCCESS = "COMPARE_POLYGONS_CHART_SUCCESS";
export const COMPARE_POLYGONS_CHART_FAIL = "COMPARE_POLYGONS_CHART_FAIL";

export const ORG_EDIT_ORGANIZATION = "ORG_EDIT_ORGANIZATION";
export const ORG_EDIT_ORGANIZATION_SUCCESS = "ORG_EDIT_ORGANIZATION_SUCCESS";
export const ORG_EDIT_ORGANIZATION_FAIL = "ORG_EDIT_ORGANIZATION_FAIL";

export const ORG_CHANGE_TENANT_ACTIVATION = "ORG_CHANGE_TENANT_ACTIVATION";
export const ORG_CHANGE_TENANT_ACTIVATION_SUCCESS = "ORG_CHANGE_TENANT_ACTIVATION_SUCCESS";
export const ORG_CHANGE_TENANT_ACTIVATION_FAIL = "ORG_CHANGE_TENANT_ACTIVATION_FAIL";

export const ORG_GET_TENANT_BY_ID = "ORG_GET_TENANT_BY_ID";
export const ORG_GET_TENANT_BY_ID_SUCCESS = "ORG_GET_TENANT_BY_ID_SUCCESS";
export const ORG_GET_TENANT_BY_ID_FAIL = "ORG_GET_TENANT_BY_ID_FAIL";

export const ORG_DELETE_TENANT = "ORG_DELETE_TENANT";
export const ORG_DELETE_TENANT_SUCCESS = "ORG_DELETE_TENANT_SUCCESS";
export const ORG_DELETE_TENANT_FAIL = "ORG_DELETE_TENANT_FAIL";

export const ORG_GET_ORGANIZATION_BY_ID = "ORG_GET_ORGANIZATION_BY_ID";
export const ORG_GET_ORGANIZATION_BY_ID_SUCCESS = "ORG_GET_ORGANIZATION_BY_ID_SUCCESS";
export const ORG_GET_ORGANIZATION_BY_ID_FAIL = "ORG_GET_ORGANIZATION_BY_ID_FAIL";

export const ORG_GET_ORGANIZATION_USER = "ORG_GET_ORGANIZATION_USER";
export const ORG_GET_ORGANIZATION_USER_SUCCESS = "ORG_GET_ORGANIZATION_USER_SUCCESS";
export const ORG_GET_ORGANIZATION_USER_FAIL = "ORG_GET_ORGANIZATION_USER_FAIL";

export const ORG_GET_TENANT_USER = "ORG_GET_TENANT_USER";
export const ORG_GET_TENANT_USER_SUCCESS = "ORG_GET_TENANT_USER_SUCCESS";
export const ORG_GET_TENANT_USER_FAIL = "ORG_GET_TENANT_USER_FAIL";

export const ORG_UPDATE_ORGANIZATION_USER = "ORG_UPDATE_ORGANIZATION_USER";
export const ORG_UPDATE_ORGANIZATION_USER_SUCCESS = "ORG_UPDATE_ORGANIZATION_USER_SUCCESS";
export const ORG_UPDATE_ORGANIZATION_USER_FAIL = "ORG_UPDATE_ORGANIZATION_USER_FAIL";

export const ORG_UPDATE_TENANT_USER = "ORG_UPDATE_TENANT_USER";
export const ORG_UPDATE_TENANT_USER_SUCCESS = "ORG_UPDATE_TENANT_USER_SUCCESS";
export const ORG_UPDATE_TENANT_USER_FAIL = "ORG_UPDATE_TENANT_USER_FAIL";

export const ORG_CHANGE_TENANT_PASSWORD = "ORG_CHANGE_TENANT_PASSWORD";
export const ORG_CHANGE_TENANT_PASSWORD_SUCCESS = "ORG_CHANGE_TENANT_PASSWORD_SUCCESS";
export const ORG_CHANGE_TENANT_PASSWORD_FAIL = "ORG_CHANGE_TENANT_PASSWORD_FAIL";

export const ORG_GET_ORGANIZATION_USAGE = "ORG_GET_ORGANIZATION_USAGE";
export const ORG_GET_ORGANIZATION_USAGE_SUCCESS = "ORG_GET_ORGANIZATION_USAGE_SUCCESS";
export const ORG_GET_ORGANIZATION_USAGE_FAIL = "ORG_GET_ORGANIZATION_USAGE_FAIL";

export const ORG_DOWNLOAD_USAGE = "ORG_DOWNLOAD_USAGE";
export const ORG_DOWNLOAD_USAGE_SUCCESS = "ORG_DOWNLOAD_USAGE_SUCCESS";
export const ORG_DOWNLOAD_USAGE_FAIL = "ORG_DOWNLOAD_USAGE_FAIL";

export const ORG_GET_USER_TOKEN = "ORG_GET_USER_TOKEN";
export const ORG_GET_USER_TOKEN_SUCCESS = "ORG_GET_USER_TOKEN_SUCCESS";
export const ORG_GET_USER_TOKEN_FAIL = "ORG_GET_USER_TOKEN_FAIL";

export const ORG_MNG_GET_USER_TOKEN_BY_TENANT_ID = "ORG_MNG_GET_USER_TOKEN_BY_TENANT_ID";

export const ORG_GET_ORG_POC = "ORG_GET_ORG_POC";
export const ORG_GET_ORG_POC_SUCCESS = "ORG_GET_ORG_POC_SUCCESS";
export const ORG_GET_ORG_POC_FAIL = "ORG_GET_ORG_POC_FAIL";

export const ORG_UPDATE_ORG_POC = "ORG_UPDATE_ORG_POC";
export const ORG_UPDATE_ORG_POC_SUCCESS = "ORG_UPDATE_ORG_POC_SUCCESS";
export const ORG_UPDATE_ORG_POC_FAIL = "ORG_UPDATE_ORG_POC_FAIL";

export const ORG_ADD_ORG_POC = "ORG_ADD_ORG_POC";
export const ORG_ADD_ORG_POC_SUCCESS = "ORG_ADD_ORG_POC_SUCCESS";
export const ORG_ADD_ORG_POC_FAIL = "ORG_ADD_ORG_POC_FAIL";

export const ORG_REMOVE_ORG_POC = "ORG_REMOVE_ORG_POC";
export const ORG_REMOVE_ORG_POC_SUCCESS = "ORG_REMOVE_ORG_POC_SUCCESS";
export const ORG_REMOVE_ORG_POC_FAIL = "ORG_REMOVE_ORG_POC_FAIL";

export const DELIVERY_REPORT = "DELIVERY_REPORT";
export const DELIVERY_REPORT_SUCCESS = "DELIVERY_REPORT_SUCCESS";
export const DELIVERY_REPORT_FAIL = "DELIVERY_REPORT_FAIL";